import React from 'react';
import TopContent from './TopContent/TopContent';
import Locations from './Locations/Locations';
import PrimaryStage from 'commonComponents/Stages/PrimaryStage/PrimaryStage';
import Berlin from 'oldAssets/images/static_pages/investment_locations/Berlin.png';
import Leipzig from 'oldAssets/images/static_pages/investment_locations/Leipzig.png';
import styles from './InvestmentLocationsPage.module.scss';

const InvestmentLocationsPage = ({
  banner,
  topContent,
  locations,
  moreLocations,
  learnMore
}) => {
  const photos = { Berlin, Leipzig };

  locations.forEach(location => {
    location.photo = photos[location.city];
    location.link = `/investment-locations/${location.city.toLowerCase()}`;
  });

  return ( 
    <div className={ styles.InvestmentLocationsPage }>
      <PrimaryStage { ...banner } pageName="investmentLocations"
        type="simple"
      />
      <TopContent { ...topContent } />
      <Locations { ...{ locations, moreLocations, learnMore } } />
    </div>
  );
};
 
export default InvestmentLocationsPage;